module.exports = __webpack_public_path__ + "img/20190627162354QQ截图20190624162409.5cf12c30.png";